export enum SUBSCRIPTIONS {
  HEADING = 'Subscriptions',
  ALL_SUBSCRIPTIONS = 'All subscriptions',
  INTERNAL_USAGE_SUBSCRIPTIONS = 'Internal usage subscriptions',
}
